import axios from "axios";
import DisplaySuccess from "../component/statusComponents/displaySuccess";
import DisplayError from "../component/statusComponents/displayError/displayError";

export default class DevisService {
  // Create a new Devis

  static async createDevis(devisData, save) {
    try {
      const result = await axios.post("/devis", devisData); // POST request to create Devis
      console.log("Devis API response:", result.data);

      if (result.data) {
        if (save) save(result.data.data);
        console.log("successs");

        DisplaySuccess({
          title: "Merci d’avoir soumis votre demande. ",
          timer: 1500,
        });
      } else {
        console.log("erroooorr");

        // DisplayError("Error creating devis", <br />);
      }
    } catch (error) {
      console.error("Error creating devis:", error);
      if (error?.response?.status !== 401) {
        console.log("error?.response?.status !== 401");

        DisplayError("An error occurred while creating the devis.");
      }
    }
  }
  static async getDevisByUserId(userId) {
    try {
      const response = await axios.get(`/devis/user/${userId}`);
      return response.data; // ✅ important
    } catch (error) {
      console.error("Erreur lors de la récupération des devis :", error);
      throw error;
    }
  }

  // Fetch all Devis
  static async getAllDevis() {
    try {
      const response = await axios.get("/devis"); // Replace with actual endpoint

      console.log("🚀 ~ DevisService ~ getAllDevis ~ response:", response);
      return response; // Ensure that the response is being returned
    } catch (error) {
      console.error("Error fetching all devis:", error);
      DisplayError("An error occurred while fetching the devis.");
      throw error; // Make sure the error is thrown for proper handling
    }
  }

  // Fetch all Devis
  static async getAllClientsDevis() {
    try {
      const response = await axios.get("/devis"); // Replace with actual endpoint

      console.log("🚀 ~ DevisService ~ getAllDevis ~ response:", response);
      return response?.data?.data; // Ensure that the response is being returned
    } catch (error) {
      console.error("Error fetching all devis:", error);
      DisplayError("An error occurred while fetching the devis.");
      throw error; // Make sure the error is thrown for proper handling
    }
  }
  static async getDevisById(id) {
    try {
      const result = await axios.get(`/devis/${id}`);
      console.log("Résultat de l'API :", result.data);

      // ✅ On retourne directement result.data si c'est l'objet
      return result.data;
    } catch (error) {
      console.error("Erreur API :", error?.response?.data || error);
      DisplayError("Erreur lors de la récupération du devis.");
      return null;
    }
  }

  // Update a Devis by ID
  static async updateDevis(id, devisData, save) {
    try {
      const isFormData = devisData instanceof FormData;

      const result = await axios.put(`/devis/${id}`, devisData, {
        headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
      });
      if (result.data) {
        if (save) save(result?.data?.data);
        console.log("successsdev");
        DisplaySuccess({
          title:
            "Merci d’avoir soumis votre demande de devis. Notre équipe la traitera dans les plus brefs délais..",
          timer: 1500,
        });
      } else {
        console.log("erroooorr");

        // DisplayError("Error creating devis", <br />);
      }
    } catch (error) {
      if (error?.response?.status !== 401) {
        DisplayError("An error occurred while updating the devis.");
      }
    }
  }
  static async updateDevisStatus(id, newStatus) {
    try {
      // Send the PATCH request to update the statut
      const response = await axios.patch(`/devis/${id}/statut`, {
        statut: newStatus,
      });

      // Fetch the updated Devis to reflect the changes on the frontend
      const updatedDevis = await axios.get(`/devis/${id}`);
      return updatedDevis.data; // Return the updated data
    } catch (error) {
      console.error("Error updating Devis status:", error);
      throw error;
    }
  }

  // Delete a Devis by ID
  static async deleteDevis(id, save) {
    try {
      const result = await axios.delete(`/devis/${id}`);

      if (result.data.error === false) {
        if (save) save(result.data.data);
        DisplaySuccess(result.data.message || "Devis deleted successfully.");
      } else {
        DisplayError(result.data.message || "Failed to delete devis.");
      }
    } catch (error) {
      if (error?.response?.status !== 401) {
        DisplayError("An error occurred while deleting the devis.");
      }
    }
  }

  static async uploadFacture(id, data) {
    try {
      const result = await axios.patch(`/devis/facture/${id}/facture`, data);

      // ✅ On retourne directement result.data si c'est l'objet
      return result.data;
    } catch (error) {
      console.error("Erreur API :", error?.response?.data || error);
      DisplayError("Erreur lors de la récupération du devis.");
      return null;
    }
  }

  static getStats = async (clientId) => {
    try {
      // Ensure that clientId is not undefined or null
      if (!clientId) {
        throw new Error("Client ID is required");
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/devis/${clientId}/stats`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching stats:", error);
      throw error; // rethrow error so it can be handled elsewhere if needed
    }
  };
  static getStatistics = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/statistics`
      );
      console.log("🚀 ~ DevisService ~ getStatistics= ~ response:", response);
      return response;
    } catch (error) {
      console.error("Error fetching statistics:", error);
      throw error; // rethrow error so it can be handled elsewhere if needed
    }
  };

  static async createDevisWithFile(devisData, file, save) {
    try {
      const formData = new FormData();

      // Ajouter tous les champs du devis
      Object.entries(devisData).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((val) => formData.append(key, val));
        } else {
          formData.append(key, value);
        }
      });

      // Ajouter les fichiers
      if (file?.kbis) {
        formData.append("KBIS", file.kbis); // Nom du champ attendu par le backend
      }

      if (file?.pieceJointe) {
        formData.append("pieceJointe", file.pieceJointe); // Autre champ fichier attendu
      }

      const result = await axios.post("/devis/createdevisvisitor", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Devis API response:", result.data);

      if (result.data) {
        if (save) save(result.data.data);

        DisplaySuccess({
          title: "Merci d’avoir soumis votre demande.",
          timer: 1500,
        });
      } else {
        DisplayError("Erreur lors de la création du devis.");
      }
    } catch (error) {
      console.error("Error creating devis with file:", error);
      if (error?.response?.status !== 401) {
        DisplayError("Une erreur est survenue lors de la création du devis.");
      }
    }
  }

  static async getCompanyFacturesStatus(companyId) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/companies/${companyId}/factures-status`
      );
      return response.data; // ex: { status: "payé" }
    } catch (error) {
      console.error(
        "Erreur lors de la récupération du statut des factures :",
        error
      );
      DisplayError("Erreur lors de la récupération du statut des factures.");
      throw error;
    }
  }
}
